import { DT } from './constants';

export type TimerState = 'zone' | 'run' | 'done';

/** Run timer in ticks. Starts when leaving the start zone, stops in the end zone. */
export class RunTimer {
  state: TimerState = 'zone';
  ticks = 0;
  /** Final time in seconds once state is 'done'. */
  finished = 0;

  reset() {
    this.state = 'zone';
    this.ticks = 0;
    this.finished = 0;
  }

  /** Seconds to display. */
  get time(): number {
    return this.state === 'run' ? this.ticks * DT : this.state === 'done' ? this.finished : 0;
  }
}
